import { createSelector } from 'reselect';
import _ from 'lodash';
import { extractSettingAs } from '@macmillan-learning/gradebook-shared';

const getGradebookSettings = (state) => state.gradebook.settings;

export const selectGradingType = createSelector(
  [getGradebookSettings],
  (settings) =>
    extractSettingAs(settings, 'gradingType', (x) => _.toInteger(x.value)),
);

export const selectRoundPercentType = createSelector(
  [getGradebookSettings],
  (settings) =>
    extractSettingAs(settings, 'roundPercentType', (x) => _.toInteger(x.value)),
);

export const selectShowPercent = createSelector(
  [getGradebookSettings],
  (settings) =>
    extractSettingAs(settings, 'showPercent', (x) => x.value !== 'false'),
);
